import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment } from 'src/environment';

import {
  GetReferenceSchemesResponse,
  ReferenceScheme,
  UpsertReferenceSchemeResponse,
} from '../models/reference-scheme.model';

@Injectable({
  providedIn: 'root',
})
export class ReferenceSchemeService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/poultry-feed-advice/secure/feedadvice`;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getReferenceSchemeById(id: number): Observable<ReferenceScheme | HttpErrorResponse> {
    return this.http.get<ReferenceScheme>(`${this.baseUrl}/${id}`).pipe(
      map((response) => response),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<ReferenceScheme>{});
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  public getReferenceSchemes(country: string): Observable<ReferenceScheme[] | HttpErrorResponse> {
    return this.http
      .get<GetReferenceSchemesResponse>(
        this.baseUrl + '/referenceScheme/' + country + '/type/Broiler',
      )
      .pipe(
        map((response) => response.referenceSchemes),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<ReferenceScheme[]>[]);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }

  public upsertReferenceScheme(
    referenceScheme: ReferenceScheme,
  ): Observable<UpsertReferenceSchemeResponse | HttpErrorResponse> {
    return this.http
      .post<UpsertReferenceSchemeResponse>(`${this.baseUrl}`, referenceScheme, {})
      .pipe(
        map((d) => d),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<UpsertReferenceSchemeResponse>{});
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }

  public deleteReferenceScheme(referenceSchemeId: number) {
    return this.http.delete(`${this.baseUrl}/referenceScheme/${referenceSchemeId}`);
  }
}
